<ion-header>
  <ion-toolbar>
    <ion-title>{{ title | translate }}</ion-title>
    <ion-buttons slot="end">
      <ion-button (click)="onCancel()">
        <ion-icon name="close" slot="icon-only"></ion-icon>
      </ion-button>
    </ion-buttons>
  </ion-toolbar>
</ion-header>

<ion-content class="ion-padding" [class.processing]="isProcessing">
  <p>{{ message | translate }}</p>

  <div *ngIf="showDocumentUpload" class="document-upload">
    <ion-list lines="none">
      <ion-item *ngFor="let docType of documentEntries" class="upload-section">
        <ion-label>
          <h3>{{ getDocumentName(docType.key) }}
            <span class="allowed-formats">({{ getAllowedFormatsText(docType.key) }})</span>
          </h3>
          <div class="upload-control" [class.is-valid]="selectedFiles[docType.key]">
            <label class="file-input-label">
              <input type="file" (change)="onFileSelected($event, docType.key)"
                [accept]="getAllowedFormatsForInput(docType.key)">
              <span class="file-input-text">{{ selectedFiles[docType.key] ? selectedFiles[docType.key]?.name :
                ('CHOOSE_FILE' | translate) }}</span>
            </label>
            <div class="status-icon" *ngIf="selectedFiles[docType.key]">
              <ion-icon name="checkmark-circle" color="success"></ion-icon>
            </div>
          </div>
        </ion-label>
      </ion-item>
    </ion-list>
  </div>

  <div *ngIf="isUploading || isProcessing" class="spinner-container">
    <ion-spinner name="crescent"></ion-spinner>
    <span class="spinner-text">
      {{ isUploading ? ('UPLOADING_FILES' | translate) : ('PROCESSING' | translate) }}
    </span>
  </div>
</ion-content>

<ion-footer [class.hidden]="isUploading || isProcessing">
  <ion-toolbar>
    <div class="button-group">
      <ng-container *ngIf="isError">
        <ion-button (click)="onConfirm()" expand="block">{{ 'CLOSE' | translate }}</ion-button>
      </ng-container>
      <ng-container *ngIf="!isError">
        <ion-button fill="clear" (click)="onCancel()" *ngIf="title !== 'Succesful registration'"
          [disabled]="isProcessing">
          {{ cancelButtonText | translate }}
        </ion-button>
        <ion-button [color]="confirmButtonColor" (click)="onConfirm()"
          [disabled]="(showDocumentUpload && !isDocumentsValid) || isProcessing">
          {{ confirmButtonText | translate }}
        </ion-button>
      </ng-container>
    </div>
  </ion-toolbar>
</ion-footer>